import { render, staticRenderFns } from "./AthleteAccessControlForm.vue?vue&type=template&id=5bad60a3&scoped=true&"
import script from "./AthleteAccessControlForm.vue?vue&type=script&lang=ts&"
export * from "./AthleteAccessControlForm.vue?vue&type=script&lang=ts&"
import style0 from "./AthleteAccessControlForm.vue?vue&type=style&index=0&id=5bad60a3&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5bad60a3",
  null
  
)

export default component.exports